import React, { useEffect } from "react";
import PageShell from "../components/PageShell";
import { Mail, MessageSquare, Globe2, Clock } from "lucide-react";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact — topastrologerinindia.com";
  }, []);
  return (
    <PageShell
      title="Contact the Editorial Team"
      subtitle="Editorial questions, listing requests, corrections and feedback."
    >
      <p className="text-[15px] leading-relaxed text-slate-700">
        topastrologerinindia.com is operated by an independent editorial team in India. If you
        want to suggest an astrologer for our ranking, report incorrect information, request a
        correction, or partner with us editorially, please reach out using the channels below.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        <div className="border border-slate-200 rounded-lg p-5">
          <div className="flex items-center gap-2 text-[#16a3a8] font-bold">
            <Mail className="w-4 h-4" /> Email
          </div>
          <a
            href="mailto:sachinsharma6886@gmail.com"
            className="block mt-2 text-sm font-semibold text-[#0b1e3f] hover:text-[#16a3a8]"
          >
            sachinsharma6886@gmail.com
          </a>
          <p className="text-xs text-slate-500 mt-1">Best for editorial enquiries.</p>
        </div>

        <div className="border border-slate-200 rounded-lg p-5">
          <div className="flex items-center gap-2 text-[#16a3a8] font-bold">
            <MessageSquare className="w-4 h-4" /> Astrology consultation
          </div>
          <p className="text-sm text-slate-700 mt-2 leading-relaxed">
            For an actual consultation, please return to the homepage and choose an astrologer
            from our top-5 ranking. We do not provide astrology readings ourselves.
          </p>
        </div>

        <div className="border border-slate-200 rounded-lg p-5">
          <div className="flex items-center gap-2 text-[#16a3a8] font-bold">
            <Globe2 className="w-4 h-4" /> Location
          </div>
          <p className="text-sm text-slate-700 mt-2">India — fully online editorial operation.</p>
        </div>

        <div className="border border-slate-200 rounded-lg p-5">
          <div className="flex items-center gap-2 text-[#16a3a8] font-bold">
            <Clock className="w-4 h-4" /> Response time
          </div>
          <p className="text-sm text-slate-700 mt-2">We typically reply within 1–2 business days.</p>
        </div>
      </div>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-10 mb-2">Want to be listed?</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        If you are a practising astrologer in India with 5+ years of verifiable experience and
        positive client feedback, you may apply to be considered for our ranking. Please email us
        a short bio, your specialisations (Vedic, KP, Nadi, Tarot, etc.), years of practice, and
        2–3 client references.
      </p>
    </PageShell>
  );
};

export default Contact;
